import type { FaireProductEntity } from "../../entity_types/product";

export const p_q37vysh9xc: FaireProductEntity = {
  token: "p_q37vysh9xc",
  type: "product",
  name: "Brown Bandana Zip Sweater",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/caae90ae05ac8da0bc357d0ff56a02ea0e661403f550cc600dd54e740c6d3fb2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/84c4ce4f7517c8c85b10ad2e08057947471c4c59a2b1797951414a48c5e7175e.jpeg",
    "https://cdn.faire.com/fastly/ef8bb0f4983644281c96051e16f78dd8f2033d7e8ff8a2233a5026f84a19e31b.jpeg",
    "https://cdn.faire.com/fastly/ee105ecb92f8dae11d35c69f2245327a36140120c233674674fe7bb7e7be1405.jpeg",
    "https://cdn.faire.com/fastly/61c00f49e952bf0f620be9a9487ca945c1f68379d4dedd66f235043588730c50.jpeg"
  ],
  priceDollars: 33.95,
  description: "Brown Bandana Zip Sweater featuring an allover black bandana-inspired pattern, designed with a classic collar, front zip closure, two front pockets, long sleeves, and a relaxed fit in a soft knit fabric for casual everyday wear or layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:57.069Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
